// Global Instructions Rule Applied!

import { RoundState, RoundsAction } from '../../interfaces/rounds.ts'
import {
  SET_FILTER_OPTIONS,
  SET_ROUNDS,
  SET_ACTIVE_FILTERS,
  SET_ACTIVE_SORTING,
  CLEAR_ACTIVE_FILTERS,
  CLEAR_ACTIVE_SORTING,
  UPDATE_ROUND_RECORD,
  ADD_ROUND,
  REMOVE_ROUND
} from './constants.ts'
import { RoundEntryFields } from '../../data_models/round_entry.ts'

const roundsReducer = (
  state: RoundState = {
    filterOptions: {
      data: {}
    },
    activeFilters: [],
    activeSorting: null,
    data: []
  },
  action: RoundsAction
): RoundState => {
  switch (action.type) {
    case SET_FILTER_OPTIONS:
      const { response: filterOptionsResponse } = action.payload

      return {
        ...state,
        filterOptions: filterOptionsResponse
      }

    case SET_ROUNDS:
      const { rounds } = action.payload

      return {
        ...state,
        data: rounds
      }

    case SET_ACTIVE_FILTERS:
      const { filters: activeFilters } = action.payload

      return {
        ...state,
        activeFilters
      }

    case SET_ACTIVE_SORTING:
      const { sorting: activeSorting } = action.payload

      return {
        ...state,
        activeSorting
      }

    case CLEAR_ACTIVE_FILTERS:
      return {
        ...state,
        activeFilters: []
      }

    case CLEAR_ACTIVE_SORTING:
      return {
        ...state,
        activeSorting: null
      }

    case UPDATE_ROUND_RECORD:
      const { roundId, updates } = action.payload

      return {
        ...state,
        data: state.data.map((round) =>
          round[RoundEntryFields.rounds__id] === roundId ? { ...round, ...updates } : round
        )
      }

    case ADD_ROUND:
      const { round: newRound } = action.payload

      // Check if round already exists, if so update it, otherwise add it
      const existingRoundIndex = state.data.findIndex(
        (round) => round[RoundEntryFields.rounds__id] === newRound[RoundEntryFields.rounds__id]
      )

      if (existingRoundIndex >= 0) {
        // Update existing round
        return {
          ...state,
          data: state.data.map((round, index) => (index === existingRoundIndex ? { ...round, ...newRound } : round))
        }
      } else {
        // Add new round
        return {
          ...state,
          data: [newRound, ...state.data]
        }
      }

    case REMOVE_ROUND:
      const { roundId: removedRoundId } = action.payload

      return {
        ...state,
        data: state.data.filter((round) => round[RoundEntryFields.rounds__id] !== removedRoundId)
      }

    default:
      return state
  }
}

export default roundsReducer
export * from './round_actions.ts'
export * from './selectors.ts'
